import LabelCreation from "./labels/label-creation.js";
import LabelProperties from "./labels/label-properties.js";

import LabelLinking from "./labels/label-linking.js";

class Labels {
    constructor(wrapCtx, evtCtx, shlWrapCtx, shlEvtCtx, controllers) {
        const {
            canvasLabelLinker,
            labelControllers: {
                creator: labelCreator,
                properties: labelProperties,
            },
        } = controllers;

        this._labelCreation = new LabelCreation(evtCtx, shlWrapCtx, shlEvtCtx, labelCreator);

        this._labelProperties = new LabelProperties(evtCtx, shlWrapCtx, shlEvtCtx, labelProperties);

        this._labelLinking = new LabelLinking(canvasLabelLinker);
    }

    get labels() {
        return this._labelCreation.labels;
    }

    track(data) {
        if (data) {
            this._labelCreation.track(data.liveLabels);

            this._labelProperties.trackContent(data.liveLabels);
            this._labelProperties.trackPositions(data.liveLabelPositions);
            this._labelProperties.trackVisibility(data.liveLabels);
            this._labelProperties.trackLabels(this._labelCreation.labels);

            this._labelLinking.track(this._labelCreation.labels);
        } else {
            this._labelCreation.track();

            this._labelProperties.trackContent();
            this._labelProperties.trackPositions();
            this._labelProperties.trackVisibility();
            this._labelProperties.trackLabels();

            this._labelLinking.track();
        }
    }

    update() {
        this._labelCreation.update();

        this._labelProperties.update();

        this._labelLinking.update();
    }
}

export default Labels;
